import { render, staticRenderFns } from "./ScanProductInput.vue?vue&type=template&id=22108ac0&scoped=true&"
import script from "./ScanProductInput.vue?vue&type=script&lang=js&"
export * from "./ScanProductInput.vue?vue&type=script&lang=js&"
import style0 from "./ScanProductInput.vue?vue&type=style&index=0&id=22108ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22108ac0",
  null
  
)

export default component.exports